
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/yard-task-orchestration",
      function () {
        return require("private-next-pages/ai/yard-task-orchestration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/yard-task-orchestration"])
      });
    }
  